import React from 'react';
import { Drawer, Grid, Modal } from 'antd';

const { useBreakpoint } = Grid;

interface IProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  closeIcon?: React.ReactNode;
  [key: string]: unknown;
  height?: string;
}

const CustomModal: React.FC<IProps> = ({ open, onClose, title, children, height, closeIcon, ...restProps }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  return isMobile ? (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      placement="bottom"
      height={height || 'auto'}
      className="rounded-t-2xl"
      closeIcon={false}
      {...restProps}
      styles={{
        body: { padding: '10px' },
        header: { padding: '15px' }
      }}
    >
      {children}
    </Drawer>
  ) : (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      footer={null}
      centered
      className="md:rounded-2xl"
      closeIcon={closeIcon}
      {...restProps}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
